import EditLink from './EditLink';

export default EditLink;
